import { render } from "./ProposalDraftInfoMessage.vue?vue&type=template&id=eec4cb66&scoped=true"
import script from "./ProposalDraftInfoMessage.vue?vue&type=script&lang=js"
export * from "./ProposalDraftInfoMessage.vue?vue&type=script&lang=js"

import "./ProposalDraftInfoMessage.vue?vue&type=style&index=0&id=eec4cb66&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eec4cb66"]])

export default __exports__